import { render, staticRenderFns } from "./RegistrationIndex.vue?vue&type=template&id=227dd61a&scoped=true&"
import script from "./RegistrationIndex.vue?vue&type=script&lang=js&"
export * from "./RegistrationIndex.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationIndex.vue?vue&type=style&index=0&id=227dd61a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227dd61a",
  null
  
)

export default component.exports